var map = {
	"./033-bm.webp": 1210,
	"./033-cn.webp": 1211,
	"./033.webp": 1212,
	"./13-bm.webp": 1213,
	"./13-cn.webp": 1214,
	"./13.webp": 1215,
	"./3-bm.webp": 1216,
	"./3-cn.webp": 1217,
	"./3.webp": 1218,
	"./angpao-bg-mobile.jpg": 1219,
	"./angpao-bg.jpg": 1220,
	"./angpao-bm.webp": 1221,
	"./angpao-cn.webp": 1222,
	"./angpao.webp": 1223,
	"./button.png": 1224,
	"./close-eye.png": 1225,
	"./coin-1.png": 1226,
	"./coin.png": 1227,
	"./ketupak-open.png": 1228,
	"./ketupak.png": 1229,
	"./ketupak_ribbon.png": 1230,
	"./rain-1.png": 1231,
	"./rain-2.png": 1232,
	"./rain-3.png": 1233,
	"./raya-bg-mobile.png": 1234,
	"./raya-bg.png": 1235,
	"./shine.png": 1236,
	"./star-1.png": 1237,
	"./star-2.png": 1238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;